import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import LandingPage from './pages/LandingPage';
import HomeschoolPage from './pages/HomeschoolPage';
import NotAvailablePage from './pages/NotAvailablePage';
import HelpCenterPage from './pages/HelpCenterPage';
import AboutPage from './pages/AboutPage';
import BlogPage from './pages/BlogPage';
import BlogPostPage from './pages/BlogPostPage';
import MissionPage from './pages/MissionPage';
import { BlogProvider } from './context/BlogContext';
import CalendarButton from './components/CalendarButton';
import Footer from './components/Footer';
import GoToTop from './components/GoToTop';
import { LanguageProvider } from './context/LanguageContext';
import { AuthProvider } from './context/AuthContext';
import NotFoundPage from './pages/NotFoundPage';
import BetaSignupPage from './pages/BetaSignupPage';
import PricingPage from './pages/PricingPage';
import AccountPage from './pages/AccountPage';

const App: React.FC = () => {
  return (
    <div style={{ opacity: 1 }}>
      <AuthProvider>
        <LanguageProvider>
          <BlogProvider>
            <Navbar />
            <CalendarButton />
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/homeschool" element={<HomeschoolPage />} />
              <Route path="/login" element={<NotAvailablePage />} />
              <Route path="/help" element={<HelpCenterPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/:slug" element={<BlogPostPage />} />
              <Route path="/mission" element={<MissionPage />} />
              <Route path="/beta" element={<BetaSignupPage />} />
              <Route path="/pricing" element={<PricingPage />} />
              <Route path="/account" element={<AccountPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
            <Footer />
            <GoToTop />
          </BlogProvider>
        </LanguageProvider>
      </AuthProvider>
    </div>
  );
};

export default App; 
